import { useQuery } from "@tanstack/react-query";
import { api } from "api";
import { useFetchStateHelper } from "hooks/useFetchState";

const useApplications = () => {
  const { data: applications, ...queryResponse } = useQuery({
    queryKey: ["applications"],
    queryFn: () => api.opekepe.getFarmerApplications(),
  });
  const { fetchState } = useFetchStateHelper(queryResponse);

  return { applications, fetchState };
};

const useApplication = (appId) => {
  const { data: application, ...queryResponse } = useQuery({
    queryKey: ["application", appId],
    queryFn: () => api.opekepe.getFarmerApplication(appId),
  });

  const { fetchState } = useFetchStateHelper(queryResponse);

  return { application, fetchState };
};

export { useApplications, useApplication };
